import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { rem } from 'design-system';
import CreditReportLenderLogo from './CreditReportLenderLogo';
const MAX_LOGOS = 8;
/**
 * Logos of the lenders behind the given debts, fanned out when there's more
 * than one lender.
 */
const CreditReportDebtLogos = ({ debts }) => {
    const lenders = useMemo(() => {
        const byLender = new Map();
        debts.forEach((debt) => {
            const key = debt.iconUrl ?? debt.lenderName ?? String(debt.accountId);
            if (!byLender.has(key))
                byLender.set(key, debt);
        });
        return [...byLender.values()].slice(0, MAX_LOGOS);
    }, [debts]);
    if (!lenders.length)
        return null;
    if (lenders.length === 1) {
        const [lender] = lenders;
        return (<View style={styles.row}>
        <CreditReportLenderLogo iconUrl={lender.iconUrl} name={lender.lenderName}/>
      </View>);
    }
    return (<View style={styles.row}>
      {lenders.map((lender, index) => (<View key={lender.networthAccountId ?? lender.accountId ?? index} style={[styles.slot, index < lenders.length - 1 && styles.overlap]}>
          <CreditReportLenderLogo iconUrl={lender.iconUrl} name={lender.lenderName} style={rotationStyles[index % rotationStyles.length]}/>
        </View>))}
    </View>);
};
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    slot: {
        width: rem(36),
        height: rem(36),
        alignItems: 'center',
        justifyContent: 'center',
    },
    overlap: {
        marginRight: rem(-8),
    },
});
const rotations = StyleSheet.create({
    right: { transform: [{ rotate: '8deg' }] },
    left: { transform: [{ rotate: '-8deg' }] },
});
const rotationStyles = [rotations.left, rotations.right];
export default CreditReportDebtLogos;
